/* eslint-disable @typescript-eslint/no-deprecated */

import React from 'react'
import styled from 'styled-components'
import { TypographyCaption } from '../../../buildingBlocks'
import { Breakpoint, BreakpointAsMaxValue } from '../../../styles'
import { useBreakpoints } from '../../../utils'
import { Content } from '../../ContentContainer'
import { FiltersIcon } from '../../../buildingBlocks/Icons/FiltersIcon'
import { DesktopSearchMenu } from './components/DesktopSearchMenu'
import { MobileSearchMenu } from './components/MobileSearchMenu'

export interface SearchMenuLayoutProps {
  menuHeading: string
  menu: React.ReactNode
  isMenuOpenOnMobile: boolean
  toggleMenuCallback: () => void
}

export const SearchMenuLayout: React.FC<React.PropsWithChildren<SearchMenuLayoutProps>> = ({
  menuHeading,
  menu,
  toggleMenuCallback,
  isMenuOpenOnMobile,
  children,
}) => {
  const { isTabletOrSmaller } = useBreakpoints()

  return (
    <>
      <Container>
        {isTabletOrSmaller && (
          <MobileSearchMenu heading={menuHeading} isOpen={isMenuOpenOnMobile} toggleOpen={toggleMenuCallback}>
            {menu}
          </MobileSearchMenu>
        )}
        {!isTabletOrSmaller && <DesktopSearchMenu heading={menuHeading}>{menu}</DesktopSearchMenu>}
      </Container>
      <Content tabIndex={0}>
        <FiltersButton tabIndex={0} onClick={toggleMenuCallback} type="button">
          <FiltersIcon height={22} width={22} />
          <TypographyCaption m={0}>Filters</TypographyCaption>
        </FiltersButton>
        {children}
      </Content>
    </>
  )
}

const Container = styled.aside`
  display: flex;
  @media (max-width: ${BreakpointAsMaxValue.tablet}) {
    flex-direction: column;
  }
`

const FiltersButton = styled.button`
  border: none;
  cursor: pointer;
  background: none;
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  margin-top: 1.5rem;
  svg {
    margin-right: 1.6rem;
  }
  @media (min-width: ${Breakpoint.tablet}) {
    display: none;
  }
`
